// src/components/SMACallback.js
import React, { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import enirisLogo from '../img/logo.png';

const SMACallback = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const didRun = useRef(false);
    const [message, setMessage] = useState('Bezig met verbinden...');

    useEffect(() => {
        if (didRun.current) return; // guard against React StrictMode double-invoke
        didRun.current = true;

        const params = new URLSearchParams(location.search);
        const code = params.get('code');
        const state = params.get('state');
        const error = params.get('error');
        const errorDescription = params.get('error_description');

        // Handle explicit OAuth error from provider
        if (error) {
            console.error('OAuth error from SMA:', error, errorDescription || '');
            setMessage('Fout bij verbinden. Probeer opnieuw.');
            setTimeout(() => navigate('/'), 2000);
            return;
        }

        const storedState = localStorage.getItem('oauth_state');
        if (!state || state !== storedState) {
            console.error('State mismatch. Possible CSRF attack.');
            setMessage('Ongeldige sessie. Probeer opnieuw.');
            setTimeout(() => navigate('/'), 1500);
            return;
        }

        // Clear state immediately after validation
        localStorage.removeItem('oauth_state');

        // Optional PKCE support if you stored a code_verifier during the authorize step
        const pkceVerifier = localStorage.getItem('pkce_verifier') || undefined;
        if (pkceVerifier) localStorage.removeItem('pkce_verifier');

        if (!code) {
            console.error('No authorization code received.');
            setMessage('Geen code ontvangen. Probeer opnieuw.');
            setTimeout(() => navigate('/'), 1500);
            return;
        }

        // Exchange code at your backend
        (async () => {
            try {
                setMessage('Bezig met tokens ophalen...');
                // Correct the fetch URL to match your Flask Blueprint route
                const res = await fetch('http://localhost:4000/api/exchange-token', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    credentials: 'include',
                    body: JSON.stringify({
                        code,
                        // Ensure this matches what you registered at SMA
                        redirect_uri: `${window.location.origin}/sma/callback`,
                        code_verifier: pkceVerifier,
                    }),
                });

                if (!res.ok) {
                    const text = await res.text().catch(() => '');
                    throw new Error(`Exchange failed (${res.status}): ${text}`);
                }

                const data = await res.json();

                // Example: store minimal flag; prefer httpOnly cookies for real tokens
                localStorage.setItem('sma_connected', 'true');

                // // Optionally persist refresh_token securely server-side only.
                // // Navigate to success page or dashboard
                setMessage('Verbonden! Even geduld…');
                // setTimeout(() => navigate('/integrations/sma/success'), 500);
            } catch (e) {
                console.error(e);
                setMessage('Kon geen tokens ophalen. Probeer opnieuw.');
                setTimeout(() => navigate('/'), 2000);
            }
        })();
    }, [location, navigate]);

    return (
        <div className="flex items-center justify-center min-h-screen bg-gray-100">
            <div className="bg-white p-8 rounded-lg shadow-lg max-w-sm w-full text-center">
                <img
                    src={enirisLogo}
                    alt="Eniris Logo"
                    className="mx-auto h-12 mb-6"
                />
                <h1 className="text-2xl font-bold mb-4 text-gray-800 animate-pulse">
                    Processing...
                </h1>
                <p className="text-gray-600">{message}</p>
            </div>
        </div>
    );
};

export default SMACallback;
